import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  FIXED,
  MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { internationalCoordinatorGroups } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
import { getCoordinatorCrqDashboard } from 'AppSrc/core/crq/crq-queries';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { CrqListErrorAlert } from 'AppSrc/core/components/crqs-screen/crq-list-error-alert';
import { CoordinatorWorkQueueDisplay } from './coordinator-work-queue-display';
import { DEFAULT_TAB } from './coordinator-work-queue-constants';

// container component with state
class CoordinatorWorkQueueUnconnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: DEFAULT_TAB,
      stats: {},
      crqLists: null,
      fetching: false,
      hasError: false,
      hasICMGroup: '',
    };
    this.handleTabClick = this.handleTabClick.bind(this);
    this.fetchCrqData = this.fetchCrqData.bind(this);
    this.clearError = this.clearError.bind(this);
    this.getCordinatorDefaultGroupFixed = this.getCordinatorDefaultGroupFixed.bind(this);
  }

  componentDidMount() {
    const newTab = JSON.parse(window.sessionStorage.getItem('BucketTabSession'));
    const lastTab = newTab ? newTab.slice(-1)[0] : DEFAULT_TAB;
    // setState from default tp selected tab session
    this.setState({ selectedTab: lastTab, fetching: true });
    // check user has analyst access and default group from ICM group
    const groupName = this.getCordinatorDefaultGroupFixed();
    const isDefaultGroupICM = internationalCoordinatorGroups.includes(groupName);
    console.log('KICM', groupName, isDefaultGroupICM, internationalCoordinatorGroups);
    if (this.props.isChangeAnalyst && isDefaultGroupICM) {
      this.setState({ hasICMGroup: 'VNO INCP Change Management' });
      // this.fetchCrqData('Change Management');
    }
    // delay fetch request to update state
    setTimeout(() => {
      this.fetchCrqData(this.state.hasICMGroup);
    }, 1000);
  }

  // Check return group name if user part if international group either return null
  getCordinatorDefaultGroupFixed() {
    // const coordinatorDefaultGroupFixed = this.props.userGroups[FIXED] && this.props.userGroups[FIXED][0] === 'VNO INCP Change Management' ? this.props.userGroups[FIXED][0] : null;
    const coordinatorDefaultGroupFixed = this.props.userRoles[FIXED] === 'coordinator' && this.props.userGroups[MOBILE] && internationalCoordinatorGroups.includes(this.props.userGroups[FIXED][0]) ? this.props.userGroups[FIXED][0] : null;
    // const coordinatorDefaultGroupFixed = this.props.userRoles[FIXED] === 'coordinator' && internationalCoordinatorGroups.includes(this.props.userGroups[FIXED][0]) ? this.props.userGroups[FIXED][0] : null;
    // console.log('kicm2', this.props.isChangeAnalyst, coordinatorDefaultGroupFixed, this.props.userRoles[FIXED], this.props.userGroups[MOBILE], this.props.userGroups[FIXED][0], internationalCoordinatorGroups.includes(this.props.userGroups[FIXED][0]));
    return coordinatorDefaultGroupFixed;
  }

  fetchCrqData(param) {
    getCoordinatorCrqDashboard(param).then(({ results, stats }) => {
      // DISPATCH HERE FREYJA
      this.setState({
        stats,
        crqLists: results,
        fetching: false,
        hasError: false,
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        fetching: false,
        hasError: true,
      });
    });
  }

  clearError() {
    this.setState({ hasError: false, fetching: false });
  }

  handleTabClick(tab) {
    this.setState({ selectedTab: tab, fetching: true });
    this.fetchCrqData(this.state.hasICMGroup);
  }

  render() {
    const {
      selectedTab,
      stats,
      fetching,
      crqLists,
      hasError,
    } = this.state;
    if (hasError) {
      return (
        <CrqListErrorAlert
          clearError={this.clearError}
        />
      );
    }
    if (fetching && !crqLists) {
      return (
        <div className="home-screen-loader">
          <LoadingSpinner />
        </div>
      );
    }
    const crqList = (crqLists && crqLists[selectedTab]) || [];
    return (
      <CoordinatorWorkQueueDisplay
        crqList={crqList}
        selectedTab={selectedTab}
        handleTabClick={this.handleTabClick}
        stats={stats}
        fetching={fetching}
      />
    );
  }
}
CoordinatorWorkQueueUnconnected.propTypes = {
  isChangeAnalyst: PropTypes.bool, // isChangeAnalyst PropTypes checking
  userGroups: PropTypes.objectOf(PropTypes.array),
  userRoles: PropTypes.objectOf(PropTypes.array),
};

const mapStateToProps = (state, ownProps) => {
  const userGroups = state && state.auth.user.groups;
  const isChangeAnalyst = state && state.auth.isChangeAnalyst;
  const userRoles = state && state.auth.user.roles;// Fetching if the user is changeAnalyst or not

  return ({
    userGroups,
    isChangeAnalyst,
    userRoles,
  });
};
const CoordinatorWorkQueue = connect(
  mapStateToProps,
)(CoordinatorWorkQueueUnconnected); // Wrapping method SectionSummaryHeaderConnect within Connect

export { CoordinatorWorkQueue };
